import { render, staticRenderFns } from "./StoreShoppingList_Item.vue?vue&type=template&id=31b8ba93&"
import script from "./StoreShoppingList_Item.vue?vue&type=script&lang=js&"
export * from "./StoreShoppingList_Item.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports